// Coresponding with Django CallItem model
export const CALL_LIST_STATUS_NEW = 1;
export const CALL_LIST_STATUS_ATTEMPT_1 = 2;
export const CALL_LIST_STATUS_ATTEMPT_2 = 3;
export const CALL_LIST_STATUS_ATTEMPT_3 = 4;
export const CALL_LIST_STATUS_CONNECTED_DECLINED = 5;
export const CALL_LIST_STATUS_CONNECTED_QUOTED = 6;
export const CALL_LIST_STATUS_UNABLE_TO_CONNECT = 7;

export const CALL_LIST_STATUSES = [
  { value: `${CALL_LIST_STATUS_NEW}`, label: 'New' },
  { value: `${CALL_LIST_STATUS_ATTEMPT_1}`, label: 'Attempt 1' },
  { value: `${CALL_LIST_STATUS_ATTEMPT_2}`, label: 'Attempt 2' },
  { value: `${CALL_LIST_STATUS_ATTEMPT_3}`, label: 'Attempt 3' },
  {
    value: `${CALL_LIST_STATUS_CONNECTED_DECLINED}`,
    label: 'Connected Declined',
  },
  { value: `${CALL_LIST_STATUS_CONNECTED_QUOTED}`, label: 'Connected Quoted' },
  {
    value: `${CALL_LIST_STATUS_UNABLE_TO_CONNECT}`,
    label: 'Unable to Connect',
  },
];
